import {Inject, Injectable, PLATFORM_ID} from "@angular/core";
import {throwError} from "rxjs";
import {LoaderService} from "./loader.service";
import { HttpErrorResponse, HttpStatusCode } from "@angular/common/http";
import {AuthenticationService, EXTERNAL_LOGIN_URL, LOGIN_URL} from "./authentication.service";
import { ToastService} from "./toast.service";
import {TranslocoService} from "@ngneat/transloco";
import {TOAST_STATE} from '@model'
import {PAYMENT} from '../app-routing.module';
import {DOCUMENT, isPlatformServer} from "@angular/common";

@Injectable({ providedIn:'root' })
export class ErrorService {

  constructor(private loaderService: LoaderService, private authenticationService: AuthenticationService,
              private toastService: ToastService, private translocoService: TranslocoService,
              @Inject(DOCUMENT) private document: Document,
              @Inject(PLATFORM_ID) private platformId: Object) {
  }

  handleError(error: any) {
    if (isPlatformServer(this.platformId)) {
      if (error instanceof HttpErrorResponse && error.status === 200) {
        console.error('HTTP parsing error - raw response:', {
          url: error.url,
          rawBody: error.error,
        });
      }
      return throwError(() => error);
    }
    /// check if we are trying to access wspay redirect uri while calling refresh token uri
    var isWsPaymentRoute: boolean = false;
    var path: string | undefined = this.document.location.href;
    if (path && path.includes(PAYMENT)) {
      isWsPaymentRoute = true;
    }

    this.loaderService.dismissLoading();
    if (error instanceof HttpErrorResponse && error.status === HttpStatusCode.Unauthorized
      && !error.url?.includes(LOGIN_URL) && !error.url?.includes(EXTERNAL_LOGIN_URL)) {
      /// if we are trying to login on wspay uri then don't show message and don't redirect to landing with logout,
      // wspay uri are public but it is ok to try to auto login to allow loggeding user to stey login on wspay redirect
      if (isWsPaymentRoute) {
        this.authenticationService.logout(false);
      } else {
        this.toastService.showToast(TOAST_STATE.danger, this.translocoService.translate('app.common.session.timeout'));
        this.authenticationService.logout();
      }
    } else if (error instanceof HttpErrorResponse && error.status === HttpStatusCode.PayloadTooLarge) {
      this.toastService.showToast(TOAST_STATE.danger, this.translocoService.translate('app.common.server.payloadTooLarge'));
    } else if (error instanceof HttpErrorResponse && error.status !== HttpStatusCode.Unauthorized) {
      this.toastService.showToast(TOAST_STATE.danger, this.translocoService.translate('app.common.server.error'));
    } else if (error instanceof HttpErrorResponse && error.status === HttpStatusCode.Unauthorized
        && error.url?.includes(LOGIN_URL)) {
      this.toastService.showToast(TOAST_STATE.danger, this.translocoService.translate('app.common.login.error'));
    }
    return throwError(() => error);
  }
}
